import { useState } from 'react'
import {CloseIcon} from '../../assets/svg'
import Modal from 'react-bootstrap/Modal'
export default function CommonModal(props) {
    return (
        <>
            <div onClick={props.openModal} className={`w-100 cursor-pointer ${props.className}`}>
                {props.modalName}
            </div>
            <Modal show={props.show} size={props.size} centered onHide={props.handleClose}
                   className={`custom-modal ${props.className}`} backdrop={props.backdrop}>
                <Modal.Header>
                    <Modal.Title>{props.heading}</Modal.Title>
                    <button type="button" className="close" onClick={props.handleClose}>
                        <CloseIcon/>
                    </button>
                </Modal.Header>
                <Modal.Body>{props.body}</Modal.Body>
                <Modal.Footer className={`mt-2 ${props.footerDisplay}`}>
                    {props.heading == "Confirm plan & pay" || props.heading == "Change plan" ?
                        <span
                            className="c_pointer font-weight-bold classUnderLine1"
                            onClick={props.showPromoBox}
                        >
                                 ENTER PROMO CODE
                          </span>
                        : ''}

                    <button type="button" variant="primary"
                            className={`btn btn-gray1 px-3 text-uppercase ${props.hideCancelBtn}`}
                            onClick={props.handleClose}>{props.btnFirst}</button>
                    <button type="button" variant="primary"
                            className={`btn btn-black px-3 text-uppercase ${props.hideSubmitBtn}`}
                            onClick={props.submitModal}>{props.btnSecond}</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}